<h1 mat-dialog-title>New Log</h1>
<form [formGroup]="form">
  <div mat-dialog-content>
    <div layout="column">
      <mat-form-field flex>
        <input matInput placeholder="Dispatch ID" formControlName="dispatchId" />
      </mat-form-field>
      <td-message
        *ngIf="flightNotFound"
        sublabel="The flight could not be found."
        class="bgc-light-blue-200"
        icon="info"
      ></td-message>
      <ng-container *ngIf="hasFlightLogData">
        <td-message
          sublabel="This flight has already been logged."
          class="bgc-light-blue-200"
          icon="info"
        ></td-message>
        <td-data-table
          [data]="searchResults?.data"
          [columns]="columns"
          [clickable]="false"
          [sortBy]="status"
        >
        </td-data-table>
      </ng-container>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      (click)="onCreate()"
      [disabled]="form.invalid || submitting"
      *ngIf="!hasFlightLogData"
    >
      Create Log
    </button>
    <button mat-button (click)="onAddNewLog()" *ngIf="hasFlightLogData" [disabled]="submitting">
      Add New Log
    </button>
    <button mat-button (click)="onCancel()">Cancel</button>
    <!--
      <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>
    -->
  </div>
</form>
